const endpoint = '/colors-schema'

const colorsSchemaApi = ({ apiClient }) => ({
  show() {
    return apiClient.get(endpoint)
  },
  update(payload) {
    return apiClient.put(endpoint, payload)
  },
})

export default colorsSchemaApi
